import { HAS_ERRORS, RESET_ERROR_HANDLER } from '../actions/actionTypes';

const errorHandlerState  = {
   hasError: false,
   errorMessage: '', 
};

const errorHandlerReducer = (state = errorHandlerState, action) => {
    switch (action.type) {
        case HAS_ERRORS:
            return {                            
                hasError: true,
                errorMessage: action.payload, 
            };
        case RESET_ERROR_HANDLER:
            return {                            
                ...errorHandlerState
            };
        default:
            //return state;
            //TODO CHECK IF THIS IS A GOOD SOLUTION TO RESET/CLEAR THE ERROR
            return {                
                ...state,
                hasError: false,
                errorMessage: '',                 
            };
    }
}

export default errorHandlerReducer;